export default "__VITE_ASSET__CzmNXUh0__"